import React from "react";
import {
  Paper,
  Group,
  ThemeIcon,
  Stack,
  Text,
  Loader,
  Card,
  ActionIcon,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { IconInfoCircle } from "@tabler/icons-react";
import { ARTICLES } from "../../docs/docsIndex";

interface StatusDisplayCardProps {
  text: string;
  statusDetail: string;
  useLoader?: boolean;
  icon?: React.ReactNode;
  color: string;
  cubby: Cubby;
}

const StatusDisplayUnit = ({
  text,
  statusDetail,
  useLoader,
  icon,
  color,
  cubby,
}: StatusDisplayCardProps) => {
  return (
    <>
      {/* <TopRightInfoCircle infoLink={infoLink} /> */}

      <Group pr="sm" justify="center" gap="xs">
        {/* Stack texts vertically */}
        <Stack gap="xs">
          <Text
            size="sm"
            style={{
              fontWeight: 700,
            }}
          >
            {text}
          </Text>
          <Text size="xs" mt="-.8rem" c="dimmed">
            {statusDetail}
          </Text>
        </Stack>

        {/* Icon or Loader to the right */}
        {useLoader ? (
          <Loader size={24} />
        ) : (
          <ThemeIcon
            c={color}
            size="md"
            variant="filled"
            aria-label="Status icon"
          >
            {icon}
          </ThemeIcon>
        )}

        <ActionIcon
          variant="subtle"
          size="sm"
          component="a"
          target="_blank"
          mt={2}
          ml={-3}
          onClick={() =>
            cubby.setCurrentlyFocusedArticleSlug(ARTICLES.NODE_STATUS.slug)
          }
          style={{
            color: "var(--mantine-color-dark-3)",
            marginLeft: "10rem",
          }}
          aria-label="Info"
        >
          <IconInfoCircle size={16} />
        </ActionIcon>
      </Group>
    </>
  );
};

export default StatusDisplayUnit;
